import { fetchGet, fetchPost } from './fetch';
import {
  AudioDetailRequest,
  GetSubscriptionPlansResponse,
  GetSubscriptionResponse,
  GetSubscriptionStatusResponse,
} from './interface';

const API_URL = '';

export const getPlanList =
  async (req?: {}): Promise<GetSubscriptionPlansResponse | null> => {
    const url = `${API_URL}/api/v1/plan`;
    return fetchGet<GetSubscriptionPlansResponse>(url, req);
  };

export const getSubscriptionStatus = async (req: {
  historyId?: string;
}): Promise<GetSubscriptionStatusResponse | null> => {
  const url = `${API_URL}/api/v1/plan/subscription_status/:historyId`;
  return fetchGet<GetSubscriptionStatusResponse>(url, req, undefined);
};

export const getSubscription =
  async (req?: {}): Promise<GetSubscriptionResponse | null> => {
    const url = `${API_URL}/api/v1/plan/subscription`;
    return fetchGet<GetSubscriptionResponse>(url, req);
  };
